

<!-- FORM -->
<div class="alert alert-success" *ngIf="alertSuccess">
  Area of Impact saved successfully!
</div>
<div class="alert alert-success" *ngIf="alertUpdate">
    Area of Impact updated successfully!
  </div>
<div class="alert alert-danger" *ngIf="alertFailure">{{errorMessage}}
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
  </div>
<form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm">
    
  <div class="heading-div">
    <h5>CREATE AREA OF IMPACT</h5>
  </div>

  <div class="main-section">
    <div class="form-group">
      <label for="categoryName">Category <span class="star"> *</span></label>
     
      <ng-select name="categoryName" [(ngModel)]="categoryName" (change)="changeDropDown($event)" placeholder ="--Select Category--" [items] = "CategoryDropDownList" bindLabel ="categoryName" bindValue="categoryName" class="form-control input-lg custom" required></ng-select>

    </div>

    <div class="form-group">
      <label for="subCategory">Area of Impact <span class="star"> *</span></label>
      <input type="text" class="form-control" id="subCategory" placeholder="Enter sub-category" required pattern=".*\S+.*" name="subcategoryName" maxlength="100" [(ngModel)]="subCategory"
        required>
    </div>
  </div>
  <input type="text" class="form-control" name="id" [(ngModel)]="areaofimpactId" style="display: none">

  <div class="btn-div">
    <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==false && savebtn == true" [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal">SAVE</button>
    <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==true && savebtn == false" [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal">SAVE AND UPDATE</button>
    <button type="button" class="btn btn-danger" (click)="resetAreaOfImpact()"   data-toggle="modal" data-target="#myModal">RESET</button>
  </div>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
</form>


<!--table-->

<div class="outer-div">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control" id="search" maxlength="50" placeholder="Keywords here"
      [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
  </div>
</div>

<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div id="tabledemo1"  *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" (click)="sortMe('category')">Category <span class="sortupdown"><i id="category1"
            class="fa fa-sort-up"></i><i id="category2" class="fa fa-sort-down"></i></span></th>
          <th scope="col">Area Of Impact</th>
          <th scope="col" class="col-display">Created By </th>
          <th scope="col" class="col-display">Area of impact Id </th>
          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of areaOfImpactData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.category}}</td>
          <td class="news-ellipsis">{{data.subCategory}}</td>
          <td class="col-display">{{data.createdBy}}</td>
          <td class="col-display">{{data.areaofimpactId}}</td>
          <td>           
            <a id="edit{{i}}" (click)="edit(data,i)" class="edit-delete"><img src="assets/images/edit.png" class="image" title="Edit" alt="Angular Logo"></a>
            <a class="edit-delete" (click)="deleteBpg(data)" style="display: none">Delete</a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>
